const tierActions = {
  GET_SHORTLISTED: "GET_SHORTLISTED",
  GET_SHORTLISTED_SUCCESS: "GET_SHORTLISTED_SUCCESS",
  GET_SHORTLISTED_ERROR: "GET_SHORTLISTED_ERROR",
  UPDATE_SHORTLISTED: "UPDATE_SHORTLISTED",
  ADD_TO_SHORTLISTED: "ADD_TO_SHORTLISTED",
  UPDATE_SHORTLISTED_SUCCESS: "UPDATE_SHORTLISTED_SUCCESS",
  REMOVE_SHORTLISTED: "REMOVE_SHORTLISTED",
  REMOVE_SHORTLISTED_SUCCESS: "REMOVE_SHORTLISTED_SUCCESS",
  SEND_INVITE: "SEND_INVITE",
  SEND_INVITE_SUCCESS: "SEND_INVITE_SUCCESS",
  SEND_INVITE_ERROR: "SEND_INVITE_ERROR",
  GET_ROLE_DATA: "GET_ROLE_DATA",
  GET_ROLE_DATA_SUCCESS: "GET_ROLE_DATA_SUCCESS",
  GET_ROLE_DATA_ERROR: "GET_ROLE_DATA_ERROR",
  GENERATE_TIERS: "GENERATE_TIERS",
  GENERATE_TIERS_SUCCESS: "GENERATE_TIERS_SUCCESS",
  GENERATE_TIERS_ERROR: "GENERATE_TIERS_ERROR",
  TIERS_JOB: "TIERS_JOB",
  TIERS_JOB_SUCCESS: "TIERS_JOB_SUCCESS",
  TIERS_JOB_UPDATING: "TIERS_JOB_UPDATING",
  TIERS_JOB_ERROR: "TIERS_JOB_ERROR",
  TIERS_JOB_CANCEL: "TIERS_JOB_CANCEL",
  CONFIRM_TEMPLATE: "CONFIRM_TEMPLATE",
  CONFIRM_TEMPLATE_SUCCESS: "CONFIRM_TEMPLATE_SUCCESS",
  CONFIRM_TEMPLATE_ERROR: "CONFIRM_TEMPLATE_ERROR",
  BACKUP_TEMPLATE: "BACKUP_TEMPLATE",
  BACKUP_TEMPLATE_SUCCESS: "BACKUP_TEMPLATE_SUCCESS",
  BACKUP_TEMPLATE_ERROR: "BACKUP_TEMPLATE_ERROR",
  GET_ROLE_SEARCH_OBJECT: "GET_ROLE_SEARCH_OBJECT",
  GET_ROLE_SEARCH_OBJECT_SUCCESS: "GET_ROLE_SEARCH_OBJECT_SUCCESS",
  GET_ROLE_SEARCH_OBJECT_FAILURE: "GET_ROLE_SEARCH_OBJECT_FAILURE",
  SEARCH_PEOPLE: "SEARCH_PEOPLE",
  SEARCH_PEOPLE_SUCCESS: "SEARCH_PEOPLE_SUCCESS",
  SEARCH_PEOPLE_FAILURE: "SEARCH_PEOPLE_FAILURE",
  CLEAR_ROLE_SEARCH: "CLEAR_ROLE_SEARCH",
  GET_FILTERED_TIERS_LIST_SUCCESS: "GET_FILTERED_TIERS_LIST_SUCCESS",
  GET_FILTERED_TIERS_LIST_ERROR: "GET_FILTERED_TIERS_LIST_ERROR",
  CLEAR_FILTERED_TIERS: "CLEAR_FILTERED_TIERS",
  CLEAR_SHORTLISTED: "CLEAR_SHORTLISTED",
  CLEAR_SHORTLISTED_SUCCESS: "CLEAR_SHORTLISTED_SUCCESS",
  UPDATE_SHORTLISTED_STATUS: "UPDATE_SHORTLISTED_STATUS",
  UPDATE_SHORTLISTED_STATUS_SUCCESS: "UPDATE_SHORTLISTED_STATUS_SUCCESS",
  UPDATE_SHORTLISTED_STATUS_ERROR: "UPDATE_SHORTLISTED_STATUS_ERROR",
  CONFIRM_INVITE: "CONFIRM_INVITE",
  CONFIRM_INVITE_SUCCESS: "CONFIRM_INVITE_SUCCESS",
  CONFIRM_INVITE_ERROR: "CONFIRM_INVITE_ERROR",
  REJECT_INVITE: "REJECT_INVITE",
  REJECT_INVITE_SUCCESS: "REJECT_INVITE_SUCCESS",
  REJECT_INVITE_ERROR: "REJECT_INVITE_ERROR",
  UNSUBSCRIBE: "UNSUBSCRIBE",
  UNSUBSCRIBE_SUCCESS: "UNSUBSCRIBE_SUCCESS",
  UNSUBSCRIBE_ERROR: "UNSUBSCRIBE_ERROR",
  WAITLIST_INVITE: "WAITLIST_INVITE",
  WAITLIST_INVITE_SUCCESS: "WAITLIST_INVITE_SUCCESS",
  WAITLIST_INVITE_ERROR: "WAITLIST_INVITE_ERROR"
}

export default tierActions;
